import { httpRequest } from "@follaw-fr/utils/request.utils";
import { handleNetworkError } from "@follaw-fr/utils/handleNetworkError";
import type {
  CreateDashboardPayload,
  CreateDashboardResponse,
  DeleteDashboardResponse,
  UpdateDashboardPayload,
  UpdateDashboardResponse,
} from "@commons/types/api/api.types";

/**
 * Submit dashboard for creation.
 * @param payload - the dashboard to be created in backend.
 */
export const createDashboard = async (payload: CreateDashboardPayload) => {
  try {
    const response = await httpRequest<
      CreateDashboardResponse,
      CreateDashboardPayload
    >("post", "/dashboards", payload);
    return response.data;
  } catch (err) {
    handleNetworkError(err);
  }
};

/**
 * Submit dashboard for update.
 * @param id - the id of the dashboard to be patched in backend.
 * @param payload - the properties of dashboard to be patched in backend.
 */
export const updateDashboard = async (
  id: number,
  payload: UpdateDashboardPayload
) => {
  try {
    const response = await httpRequest<
      UpdateDashboardResponse,
      UpdateDashboardPayload
    >("patch", `/dashboards/${id}`, payload);
    return response.data;
  } catch (err) {
    handleNetworkError(err);
  }
};

/**
 * Submit id for dashboard deletion.
 * @param id - the id of the dashboard to be deleted in backend.
 */
export const deleteDashboard = async (id: number) => {
  try {
    const response = await httpRequest<DeleteDashboardResponse, never>(
      "delete",
      `/dashboards/${id}`
    );
    return response.data;
  } catch (err) {
    handleNetworkError(err);
  }
};
